<style lang="css">
/*分页组件命名空间*/
.wx-menutab {
  position: relative;
  font-size:16px;
}
.wx-menutab-item{
	display : inline-block;
	padding : 10px;
	cursor : pointer;
}
.wx-menutab-item-a{
	color:inherit;
}
.wx-menutab-item-flag{
    position: relative;
    color: red;
    font-size: 12px;
    top: -5px;
    font-weight: bolder;
    font-style: italic;
}
.wx-menutab-bar{
	position:relative;
	font-size:0;
}
.wx-menutab-active{
	position:absolute;
	left:0;
	width:50px;
	height:3px;
	background-color:#2baf2b;
	transition-property:width,left;
	transition-duration : 0.2s;
	-webkit-transition-property:width,left;
	-webkit-transition-duration : 0.2s;
}
</style>
<template lang="html">

	<div class="wx-menutab">
		<div class="wx-menutab-items" v-bind:id="unique">
			<div v-for="(item,seqindex) in targetMenus" class="wx-menutab-item" v-bind:class="{'wx-menutab-item-active':seqindex==index}" v-bind:id="unique+'_'+seqindex" v-on:click="clickMenu(item.key,item.name,seqindex,$event)">
                <a v-if="item.isLink" class="wx-menutab-item-a" :href="item.path" :target="item.target?item.target:'_blank'">{{item.name}}</a>
                <span v-else>{{item.name}}</span>
                <span class="wx-menutab-item-flag" v-if="item.flag">{{item.flag}}</span>
            </div>
		</div>
		<div class="wx-menutab-bar">
			<div class="wx-menutab-active" v-bind:style="{left:left,width:width}"></div>
		</div>
	</div>

</template>
<script>

//获取默认配置对象
// function _getDefaultConfig(){
// 	return {
// 		//必填，Array，菜单名称
// 		menus : [
// 			//{name:'测试菜单1',key:'key1',flag:'new'}
// 		],
// 		//必填，Integer，当前index
// 		index : 0,
// 		//选填，String,底线颜色
// 		color:'#2baf2b',
// 		//内部使用，Integer，滑条left值
// 		left : '0px',
// 		//内部使用，Integer，滑条width值
// 		width : '0px',
//         unique : 'menutab'+(new Date()).getTime(),
//         lazy:false//点击的时候是否延迟切换
// 	}
// }

export default {
	props : {
       //菜单数据
        menus : {
			type: Array,
			default : function(){
				return [];
			}
        },
        //是否延迟切换模式
        lazy:{
            type:Boolean,
            default:false
        },
        //当前勾选的菜单索引
        activeKey:{
            type:String,
            default:''
        }
	},
	data : function(){
		return {
            //内部使用，Integer，滑条left值
            left : '0px',
            //内部使用，Integer，滑条width值
            width : '0px',
            index:0,
            //唯一码
            unique : 'menutab'+(new Date()).getTime(),
        }
	},
	created : function(){
		// Object.assign(this.$data,this.options);
	},
	mounted: function(){
        this.updateIndex();
        this.updateOffset();
    },
    
    computed:{
        targetMenus:function(){
            let {menus} = this;
            return menus.map(menu=>{
                return {
                    ...menu,
                    isLink:/^http/.test(menu.path)
                }
            });
        }
    },
	methods : {
        updateOffset:function(){
            this.$nextTick(()=>{
                var target = document.getElementById(this.unique+'_'+this.index);
                if(target){
                    this.left = target.offsetLeft+'px';
                    this.width = target.offsetWidth+'px';
                }
            })
        },

        updateIndex:function(){
            let {menus=[],activeKey} = this;
            let index = menus.findIndex(item=>{
                return item.key == activeKey;
            });
            this.index = index;
        },

		clickMenu : function(key,name,index,event){
			var target = event.target;
			if(!this.lazy){
				this.index = index;
				this.left = target.offsetLeft+'px';
				this.width = target.offsetWidth+'px';
			}
			this.$emit('clickMenu',key,name,index);
		}
	},
	watch : {
        menus:function(newVal,oldVal){
            this.updateIndex();
            this.updateOffset();
        },
        activeKey:function(){
            this.updateIndex();
            this.updateOffset();
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/components/core/menutab/Menutab.vue